import {connect} from 'react-redux'
import CheckCashingTranStatus from '../components/CheckCashingTranStatusView'

const mapDispatchToProps = {

};

const mapStateToProps = (state) => {
  const { transaction_status, transaction_messages } = state.app.x_data;

  return {
    transaction_status,
    transaction_messages,
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(CheckCashingTranStatus)


// WEBPACK FOOTER //
// ./src/components/Applications/CheckCashing/containers/CheckCashingTranStatusContainer.js